
define('text!views/shop/travel/hotels.html',[],function () { return '<h1 data-content="shop.content.travel.title"></h1>\r\n\r\n<%= pf.getContent(\'shop.content.travel.body\') %>\r\n\r\n<img src="img/shop/travel/main_bg.png" alt="PayForward Travel" title="PayForward Travel" />\r\n\r\n<%= pf.getContent(\'shop.content.travel.disclaimer\') %>';});

